export default __webpack_public_path__ + "5e3967dc73b95b9887302bb65941aa47.woff";